import { render, staticRenderFns } from "./ProductCardSkeleton.vue?vue&type=template&id=0c6c575e"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@6.11.0_webpack@5.105.3__lodash@4_1f38f72e7d8f3eef61099422a8f9de15/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports